import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../utils/analytics';
export function AnalyticsTracker() {
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    // Wait one tick so the page has set its own document.title
    const t = window.setTimeout(() => trackPageView(pathname + search), 0);
    return () => window.clearTimeout(t);
  }, [pathname, search]);
  return null;
}